import { useContext, createContext, PropsWithChildren } from "react"
import { AuthService } from "../auth/shared/types"

export const AuthContext = createContext<AuthService | undefined>(undefined)

type AuthProviderProps = {
  authService: AuthService
}

export const AuthProvider = ({ children, authService }: PropsWithChildren<AuthProviderProps>) => (
  <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>
)

export function useAuth() {
  const context = useContext(AuthContext)

  if (context === undefined) {
    throw new Error(`useAuth must be used inside AuthProvider.`)
  }

  return context
}
